import { STATUS } from "../../../constants";
export const SMS_CODE_SENT_STATUS_MAPPING = {
  [STATUS.SUCCEED]: {
    className: "is-success",
    message: "The verification code has been sent to your mobile phone, please check",
  },
  [STATUS.FAILED]: {
    className: "is-danger",
    message: "Failed to send the verification code. Please try again",
  },
};
